import React from 'react';
import './navbar.css';
const Navbar = () => {
    return (
        <div className='navbar-container'>
            <div className="navbar">
                <h1>Keeper</h1>
                <span>A new way of notes sharing</span>
            </div>
        </div>
    );
}

export default Navbar;
